<template>
<div class="col-6 d-flex justify-content-end px-0">
    <!-- <el-dropdown trigger="click">
        <Button class="el-dropdown-link btn btn-outline-grey mx-2 px-3 py-2" :color="getPrimaryColor">
            <FilterIcon class="ml-0" size="16" color="#A1A8B8" />Filtrar
        </Button>
        <el-dropdown-menu slot="dropdown" class="filter-dropdown">
            <div class="d-flex flex-column">
                <caption class="c-nmdone bold mb-3">Perfil da empresa</caption>
                <el-radio :class="getPrimaryColor" v-model="filterRadio" label="1">Fornecedor</el-radio>
                <el-radio :class="getPrimaryColor" v-model="filterRadio" label="2">Comprador</el-radio>
                <el-radio :class="getPrimaryColor" v-model="filterRadio" label="0">Financiador</el-radio>
            </div>
            <div class="footer-dropdown d-flex align-items-center justify-content-end">
                <el-dropdown-item>
                    <router-link to="" @click.native="emptyStatus">
                        Limpar
                    </router-link>
                    <Button class="btn btn-blue small" @click="filterStatus" :color="getPrimaryColor">
                        Filtrar
                    </Button>
                </el-dropdown-item>
            </div>
        </el-dropdown-menu>
    </el-dropdown> -->
    <Button @click="dialogVisible = true" type="outline" color="grey" class="filter-button mx-1 px-3 py-2" v-if="showFilterButton">
        <FilterIcon class="ml-0" size="16" color="#A1A8B8" />
        <span>Filtrar</span>
        <span :class="`badge ${getPrimaryColor} filter-selected badge-filter-button-position`" v-if="totalFilters > 0">{{totalFilters}}</span>
    </Button>
    <FiltersModal :dialogVisible="dialogVisible" @closeModal="dialogVisible = $event" @empty="emptyFilters" @filter="filterRequest">
        <el-collapse v-model="activeName">
            <el-collapse-item v-if="companyTypeFilter" name="1">
                <template slot="title">
                    <div>
                        <span class="c-ndarkfour">Perfil da empresa</span>
                        <span :class="`badge ${getPrimaryColor} filter-selected badge-filter-modal-position`" v-if="filters.companyType">
                            1
                        </span>
                    </div>
                </template>
                <div class="d-flex flex-column">
                    <el-radio :class="getPrimaryColor" v-model="filters.companyType" label="1" class="`${getPrimaryColor} c-ndarkfour`">Fornecedor</el-radio>
                    <el-radio v-if="!$router.history.current.path.includes('user')" :class="getPrimaryColor" v-model="filters.companyType" label="2" class="`${getPrimaryColor} c-ndarkfour`">Comprador</el-radio>
                    <el-radio :class="getPrimaryColor" v-model="filters.companyType" label="0" class="`${getPrimaryColor} c-ndarkfour`">Financiador</el-radio>
                </div>
                <el-button type="text" :class="`mt-0 c-${getPrimaryColor}four`" @click="filters.companyType = ''">Limpar</el-button>
            </el-collapse-item>
            <el-collapse-item v-if="statusFilter" name="2">
                <template slot="title">
                    <div>
                        <span class="c-ndarkfour">Situação cadastral</span>
                        <span :class="`badge ${getPrimaryColor} filter-selected badge-filter-modal-position`" v-if="filters.registerSituation">
                            1
                        </span>
                    </div>
                </template>
                <div class="d-flex flex-column">
                    <el-radio :class="getPrimaryColor" v-model="filters.registerSituation" label="0" class="`${getPrimaryColor} c-ndarkfour`">Pendente</el-radio>
                    <el-radio :class="getPrimaryColor" v-model="filters.registerSituation" label="2" class="`${getPrimaryColor} c-ndarkfour`">Em análise</el-radio>
                    <el-radio :class="getPrimaryColor" v-model="filters.registerSituation" label="3" class="`${getPrimaryColor} c-ndarkfour`">Em revisão</el-radio>
                    <el-radio :class="getPrimaryColor" v-model="filters.registerSituation" label="1" class="`${getPrimaryColor} c-ndarkfour`">Completo</el-radio>
                </div>
                <el-button type="text" :class="`mt-0 c-${getPrimaryColor}four`" @click="filters.registerSituation = ''">Limpar</el-button>
            </el-collapse-item>
            <el-collapse-item v-if="dataFilter"  name="3">
                <template slot="title">
                    <div>
                        <span class="c-ndarkfour">Data da última atualização</span>
                        <span :class="`badge ${getPrimaryColor} filter-selected badge-filter-modal-position`" v-if="filters.filterDate.start != null && filters.filterDate.end != null">
                            1
                        </span>
                    </div>
                </template>
                <div id="calendar" :class="`${getPrimaryColor} row d-flex align-items-center`">
                    <div class="col pr-0">
                        <el-input :class="getPrimaryColor" placeholder="DD/MM/YYYY" v-model="filters.filterDate.start" v-mask="'##/##/####'">
                            <span slot="prefix">
                                <Calendar />
                            </span>
                        </el-input>
                    </div>
                    <div class="col-1 text-center">
                        <h6 class="mb-0 regular">a</h6>
                    </div>
                    <div class="col pl-0">
                        <el-input :class="getPrimaryColor" placeholder="DD/MM/YYYY" v-model="filters.filterDate.end" v-mask="'##/##/####'">
                            <span slot="prefix">
                                <Calendar />
                            </span>
                        </el-input>
                    </div>
                    <div class="col-12 mt-3">
                        <vc-date-picker
                            v-model="filters.filterDate"
                            is-range :model-config="modelConfig"
                            :color="`${getPrimaryColor}-${getWhiteLabel.toLowerCase().replace(/ /g, '')}`"
                            :attributes="[{
                                key: 'today',
                                highlight: {
                                    fillMode: 'outline'
                                },
                                dates: new Date(),
                            }]"
                        >
                        </vc-date-picker>
                    </div>
                </div>
                <el-button type="text" :class="`c-${getPrimaryColor}four`" @click='emptyFilterDate'>Limpar</el-button>
            </el-collapse-item>
            <el-collapse-item v-if="expirationDateFilter"  name="4">
                <template slot="title">
                    <div>
                        <span class="c-ndarkfour">Expira em</span>
                        <span :class="`badge ${getPrimaryColor} filter-selected badge-filter-modal-position`" v-if="filters.expirationDate.start != null && filters.expirationDate.end != null">
                            1
                        </span>
                    </div>
                </template>
                <div id="calendar" :class="`${getPrimaryColor} row d-flex align-items-center`">
                    <div class="col pr-0">
                        <el-input :class="getPrimaryColor" placeholder="DD/MM/YYYY" v-model="filters.expirationDate.start" v-mask="'##/##/####'">
                            <span slot="prefix">
                                <Calendar />
                            </span>
                        </el-input>
                    </div>
                    <div class="col-1 text-center">
                        <h6 class="mb-0 regular">a</h6>
                    </div>
                    <div class="col pl-0">
                        <el-input :class="getPrimaryColor" placeholder="DD/MM/YYYY" v-model="filters.expirationDate.end" v-mask="'##/##/####'">
                            <span slot="prefix">
                                <Calendar />
                            </span>
                        </el-input>
                    </div>
                    <div class="col-12 mt-3">
                        <vc-date-picker
                            v-model="filters.expirationDate"
                            is-range
                            :model-config="modelConfig"
                            :color="`${getPrimaryColor}-${getWhiteLabel.toLowerCase().replace(/ /g, '')}`"
                            :attributes="[{
                                key: 'today',
                                highlight: {
                                    fillMode: 'outline'
                                },
                                dates: new Date(),
                            }]"
                        >
                        </vc-date-picker>
                    </div>
                </div>
                <el-button type="text" :class="`c-${getPrimaryColor}four`" @click='emptyExpirationDate'>Limpar</el-button>
            </el-collapse-item>
            <el-collapse-item v-if="attachedContractFilter" name="5">
                <template slot="title">
                    <div>
                        <span class="c-ndarkfour">Contrato anexado</span>
                        <span :class="`badge ${getPrimaryColor} filter-selected badge-filter-modal-position`" v-if="filters.attachedContract">
                            1
                        </span>
                    </div>
                </template>
                <div class="d-flex flex-column">
                    <el-radio :class="getPrimaryColor" v-model="filters.attachedContract" label="1" class="`${getPrimaryColor} c-ndarkfour`">Sim</el-radio>
                    <el-radio :class="getPrimaryColor" v-model="filters.attachedContract" label="0" class="`${getPrimaryColor} c-ndarkfour`">Não</el-radio>
                </div>
                <el-button type="text" :class="`mt-0 c-${getPrimaryColor}four`" @click="filters.attachedContract = ''">Limpar</el-button>
            </el-collapse-item>
            <el-collapse-item v-if="(companyPartnerFilter && filters.companyType !== '') || economicGroupPartnerFilter" name="6">
                <template slot="title">
                    <div>
                        <span class="c-ndarkfour">Parceiro</span>
                        <span :class="`badge ${getPrimaryColor} filter-selected badge-filter-modal-position`" v-if="filters.companyPartner">
                            1
                        </span>
                    </div>
                </template>
                <div class="d-flex flex-column">
                    <el-radio
                        v-for="partner in partners"
                        :class="getPrimaryColor"
                        v-model="filters.companyPartner"
                        :label="partner.id"
                        class="c-ndarkfour"
                        :key="partner.id"
                    >
                        {{formatPartnerName(partner.name)}}
                    </el-radio>
                </div>
                <el-button type="text" :class="`mt-0 c-${getPrimaryColor}four`" @click="filters.companyPartner = ''">Limpar</el-button>
            </el-collapse-item>
            <el-collapse-item v-if="economicGroupFilter" name="7">
                <template slot="title">
                    <div>
                        <span class="c-ndarkfour">Grupo econômico</span>
                        <span :class="`badge ${getPrimaryColor} filter-selected badge-filter-modal-position`" v-if="filters.economicGroup">
                            1
                        </span>
                    </div>
                </template>
                <div class="d-flex flex-column economicGroups">
                    <el-radio
                        v-model="filters.economicGroup"
                        v-for="(economicGroup) in economicGroups"
                        :label="economicGroup.id.toString()" class="c-ndarkfour"
                        :key="economicGroup.name"
                        :class="getPrimaryColor"
                    >
                        <span class="break company-break">
                            {{economicGroup.name | formatName}}
                        </span>
                    </el-radio>
                </div>
                <el-button type="text" :class="`mt-0 c-${getPrimaryColor}four`" @click="filters.economicGroup = ''">Limpar</el-button>
            </el-collapse-item>
        </el-collapse>
    </FiltersModal>

    <div class="ml-3">
        <el-input  @keyup.native.enter="filterSearchQuery" placeholder="Buscar" v-model="filterSearch"  :class="`${getPrimaryColor} filter`" clearable>
            <button class="btn" slot="append" @click="filterSearchQuery">
                <SearchIcon class="mx-0"  size="16"  />
            </button>
        </el-input>
        <h6 class="regular" slot="append">
            Busque pelo nome ou CNPJ da empresa.<br> Ex.: <span :class="`c-${getPrimaryColor}four`"> Uni Impacta. </span>
        </h6>
    </div>
</div>
</template>

<script>
import Calendar from '@/components/icons/Calendar'
import getAllEconomicGroupNames from '@/api/getAllEconomicGroupNames'
import getAllPartnersActive from '@/api/getAllPartnersActive'

export default {
    components: {
        Calendar
    },
    props: {
        companyTypeFilter: {
            default: true
        },
        statusFilter: {
            default: true
        },
        dataFilter: {
            default: false
        },
        companyPartnerFilter: {
            default: false
        },
        economicGroupPartnerFilter: {
            default: false
        },
        attachedContractFilter: {
            default: false
        },
        expirationDateFilter: {
            default: false
        },
        economicGroupFilter: {
            default: false
        },
        filtersProp: {
            default: () => ({
                companyType: '',
                registerSituation: '',
                filterDate: {
                    start: null,
                    end: null
                },
                companyPartner: '',
                attachedContract: '',
                expirationDate: {
                    start: null,
                    end: null
                }
            })
        },
        filterSearchProp: {
            default: ''
        },
        showFilterButton: {
            default: true
        },
        // partners: {
        //     type: Array,
        //     default: () => []
        // }
    },
    data() {
        return {
            dialogVisible: false,
            filters: this.filtersProp,
            filterSearch: this.filterSearchProp,
            activeName: '1',
            modelConfig: {
                type: 'string',
                mask: 'DD/MM/YYYY'
            },
            totalFilters: 0,
            economicGroups: [],
            partners: [],
        }
    },
    watch: {
        filterSearch(val) {
            if (!val.length) {
                this.filterSearchQuery()
            }
        },
    },
    async created() {
        const partnersActive = await getAllPartnersActive()
        this.partners = partnersActive
        
        this.calculateTotalFilters()
        if (this.economicGroupFilter) {
            const economicGroups = await getAllEconomicGroupNames()
            this.economicGroups = economicGroups
        }
    },
    methods: {
        calculateTotalFilters() {
            let filterSum = 0
            const filtersValues = Object.values(this.filters)
            filtersValues.forEach((filter) => {
                const typeOf = typeof filter
                if (typeOf == 'string') filterSum = filter == '' || filter == null ? filterSum : filterSum + 1
                if (typeOf == 'object') {
                    const filterValues = Object.values(filter)
                    filterSum = filterValues.every(value => (value == '' || value == null)) ? filterSum : filterSum + 1
                }
            })
            this.totalFilters = filterSum
        },
        filterSearchQuery() {
            this.$emit('filterSearch', this.filterSearch)
        },
        filterStatus() {
            this.$emit('filterStatus', this.filterRadio)
        },
        emptyStatus() {
            this.filterRadio = ''
            this.$emit('emptyFilter')
        },
        emptyFilterDate() {
            this.filters.filterDate = {
                start: null,
                end: null
            }
            //this.filterRequest()

        },
        emptyExpirationDate() {
            this.filters.expirationDate = {
                start: null,
                end: null
            }
        },
        filterRequest() {
            this.$emit('filter', this.filters)
            this.calculateTotalFilters()
            this.dialogVisible = false
        },
        emptyFilters() {
            this.filters = {
                companyType: '',
                registerSituation: '',
                filterDate: {
                    start: null,
                    end: null
                },
                companyPartner: '',
                attachedContract: '',
                expirationDate: {
                    start: null,
                    end: null
                },
            }
            this.$emit('emptyFilter', this.filters)
            this.calculateTotalFilters()
            this.dialogVisible = false
        },
        formatPartnerName(partner) {
            if (!partner) return '';
            
            return partner
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        }

    }
}
</script>

<style lang="scss" scoped>
.btn.btn-outline-grey {
    padding: 11px 16px;
    height: 40px;
}
.badge-filter-modal-position {
    position: absolute;
    left: 285.5px - 20px; // ! 20px = width
}
.badge-filter-button-position {
    margin-left: 10px
}

.filter-selected {
    width: 20px;
    height: 20px;
    background-color: #3D5DFC;
    color: white;
    text-align: center;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 700;
    line-height: 20px
}

.economicGroups {
    max-height: 200px;
    overflow-y: scroll;
    overflow-x: clip;
}
</style>
